import GET_ARTICLES from "../class/getArticles";
import Swiper from "swiper/bundle";
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const [ w, d, mq ] = [window, document, window.matchMedia( "(max-width: 900px)" ) ];

const domReady = TPL => {
  new BLOCKS;
  instaAPI();
};

class BLOCKS{
  constructor() {
    this.mainvisual();
    this.news();
    this.scrollBtn();
    this.caseAnimation();
    this.partsAnimation();
    this.case();
  }

  mainvisual() {
    const mainVisual = document.querySelector('.mainvisual');
    if (!mainVisual) return;

    const showMainVisual = () => {
      setTimeout(() => {
        mainVisual.classList.add('loaded');
      }, 100);
    };

    if (document.readyState === 'complete') {
      showMainVisual();
    } else {
      window.addEventListener('load', showMainVisual);
    }

    const news_ticker = new GET_ARTICLES('.news-article[data-plugin="getArticles"]');
    news_ticker.makeItem = (item) => `

      <a class="news-link" href="${item.href}">
        <p class="news-title">NEWS</p>
        <p class="info">
          <span class="date">${item.date}</span>
          <span class="cat">${item.category.name}</span>
        </p>
        <p class="title">${item.title}</p>
        <svg class="icon icon_arrow" width="16" height="12"><use href="/assets/svg/sprite.symbol.svg#icon_arrow"></use></svg>
      </a>`;
    news_ticker.render();

    const news_pickup = new GET_ARTICLES('.news-pickup');
    const pickupWrapper = document.querySelector('.block-pickup-wrap');
    let isDisplayed = false;

    news_pickup.makeItem = (item) => {
      const categoryName = item.category.name.trim();
      if (isDisplayed || categoryName !== 'PICK UP') return '';

      isDisplayed = true;
      if (pickupWrapper) pickupWrapper.style.display = 'block';

      return `
        <div class="pickup-link">
          <img class="pickup_circle" src="/assets/img/top/pickup_circle@2x.png" alt="PICK UP" loading="lazy">
          <figure><img src="${item.thumb}" alt="${item.title}" loading="lazy"></figure>
          <div class="pickup-link-wrap">
            <h2 class="top_ttl"><strong>PICK UP</strong><span>ピックアップ</span></h2>
            <p class="title">${item.title}</p>
            <span class="desc">${item.desc}</span>
            <a href="${item.href}" class="viewmore">
              <span>View More</span>
              <svg class="icon arrow arrow_view"><use xlink:href="/assets/svg/sprite.symbol.svg#icon_arrow_long"></use></svg>
            </a>
          </div>
        </div>`;
    };
    news_pickup.render();
    } 

    // ニュース4件表示
  news() {
    const getArticle = new GET_ARTICLES('.block-news__list');
    getArticle.makeItem = (item) => {
      const articleBody = item.body ? item.body.replace(/<[^>]+>/g, '').slice(0, 88) + '...' : '';
      
      return `
      <li class="block-news__item">
        <a href="${item.href}" class="block-news__link">
          <figure class="thumb${(item.is_new)? ' is-new': ''}"><img src="${item.thumb}" alt="${item.title}" width="100%" loading="lazy"></figure>
          <p class="cate">${item.category.name}</p>
          <p class="ttl"><span>${item.title}</span></p>
          <span class="date">${item.date}</span>
        </a>
      </li>`;
    };
    getArticle.render();
  }

  scrollBtn() {
  const scrollBtn = document.querySelector(".scroll_btn");
  const fgImage = document.querySelector(".scroll_btn_fg");
  const bgElement = document.querySelector(".scroll_btn_bg");

  if (scrollBtn) {
    ScrollTrigger.config({ ignoreMobileResize: true });

    if (fgImage) {
      gsap.set(fgImage, {
        opacity: 0,
        x: 20, 
        scale: 1.1,
        transformOrigin: "right center"
      });
    }

    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: ".mainvisual",
        endTrigger: ".block-aboutus",
        start: "top top", 
        end: "top 64%",
        scrub: true,
        pin: scrollBtn,
        pinSpacing: false,
        invalidateOnRefresh: true
      }
    });

    tl.to(scrollBtn, {
      scale: () => {
        const windowWidth = window.innerWidth;
        return windowWidth < 1440 ? 4.9 * (windowWidth / 1440) : 4.9;
      },
      x: () => {
        const windowWidth = window.innerWidth;
        return windowWidth < 1440 ? -60 * (windowWidth / 1440) : -60;
      },
      y: () => {
        const windowWidth = window.innerWidth;
        return windowWidth < 1440 ? -120 * (windowWidth / 1440) : -120;
      },
      ease: "none",
      force3D: false 
    }, 0);

    if (bgElement) {
      tl.to(bgElement, {
        "--bg-color": "#ffc426",
        ease: "none"
      }, 0);
    }

    if (fgImage) {
      tl.to(fgImage, {
        opacity: 1,
        duration: 0.15,
        ease: "power1.out"
      }, 0);

      tl.to(fgImage, {
        x: -25,
        scale: 1.4,
        ease: "none",
        force3D: false
      }, 0);
    }

    window.addEventListener("load", () => {
      ScrollTrigger.refresh();
    });
  }
}

  caseAnimation() {
    const caseBlock = document.querySelector('.block-case');
    const maskLines = document.querySelectorAll('.case_svg .mask-line');

    if (!caseBlock || maskLines.length === 0) return;

    maskLines.forEach((maskLine) => {
      const pathLength = maskLine.getTotalLength ? maskLine.getTotalLength() : 3500;

      gsap.set(maskLine, {
        strokeDasharray: pathLength,
        strokeDashoffset: pathLength
      });

      gsap.to(maskLine, {
        strokeDashoffset: 0,
        duration: 3,
        ease: "power2.inOut",
        scrollTrigger: {
          trigger: caseBlock,
          start: "top 75%", 
          toggleActions: "play none none none" 
        }
      });
    });
  }

  partsAnimation() {
    const partsElements = document.querySelectorAll('.parts, .block-news_parts, .recruit_menu');
    if (partsElements.length === 0) return;

    partsElements.forEach((parts) => {
      ScrollTrigger.create({
        trigger: parts,
        start: "top 70%", 
        onEnter: () => parts.classList.add('loaded'),
      });
    });
  }

  case () {
    const getArticle = new GET_ARTICLES('.case_list .swiper-wrapper');

    getArticle.makeItem = (item) => {
      return `
      <div class="swiper-slide">
        <a href="${item.href}" class="c-card-case">
          <figure class="c-card-case__img">
            <img src="${item.thumb}" alt="${item.title}" width="100%" loading="lazy">
          </figure>
          <div class="c-card-case__body">
            <p class="cat"><span>${item.category.name}</span></p>
            <p class="ttl"><span>${item.title}</span></p>
          </div>
        </a>
      </div>`;
    };

    getArticle.render().then(() => {
      const sliderElement = document.querySelector('.case_list');
      if(!sliderElement) return;

      requestAnimationFrame(() => {
        const caseSlide = new Swiper(sliderElement, {
          speed: 500,
          slidesPerView: 1.4, // スマホ初期値
          spaceBetween: 30,
          centeredSlides: true,
          loop: true,
          loopedSlides: 5,
          slideToClickedSlide: true,
          observer: true,
          observeParents: true,
          watchSlidesProgress: true,

          // PC
          breakpoints: {
            900: {
              slidesPerView: 3.5,
              spaceBetween: 50
            }
          },

          navigation: {
            nextEl: '.case_list_parts .case-next',
            prevEl: '.case_list_parts .case-prev'
          },

          on: {
            progress(swiper) {
              swiper.slides.forEach((slide) => {
                const progress = slide.progress; 
                const rotate = progress * -7; 

                const translateY = (1 - Math.cos(progress * 0.25)) * 900;

                slide.style.transformOrigin = 'center center';
                slide.style.transform = `translate3d(0, ${translateY}px, 0) rotate(${rotate}deg)`;
              });
            },
            setTransition(swiper, duration) {
              swiper.slides.forEach((slide) => {
                slide.style.transition = `${duration}ms transform ease-out`;
              });
            }
          }
        });
      });
    });
  }
}



const jqInit = () => false;

export default function HOME () {
  // テンプレートが用意したDOMContentLoaded（テンプレートインスタンスが引数に入る）
  d.addEventListener('rwd002.beforeDomready', e => domReady(e.detail) );
  
  $(() => jqInit());
}